import { format, isAfter, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const getUnmaskedField = (value: string | undefined) => {
  if (!value) return '';
  return value.replaceAll(/[^\dA-Za-z]/g, '');
};

export const hasOnlyNumbers = (valueToCheck: string) => {
  const clearField = getUnmaskedField(valueToCheck);
  return new RegExp(/^\d+$/).test(clearField);
};

export const dateFormatter = (value?: Date | string, pattern = 'dd/MM/yyyy', options = {}): string => {
  if (!value) return '';

  if (typeof value != 'string') {
    value = value.toISOString();
  }

  const parsedValue = parseISO(value);

  if (parsedValue.toString() === 'Invalid Date') return value;

  const dateFormated = format(parsedValue, pattern, { locale: ptBR, ...options });
  return dateFormated;
};

export const isLessThanSixMonths = (dateToCompare?: string | number | Date) => {
  if (!dateToCompare) {
    return '';
  }
  const date = new Date();
  const formatTodate = new Date(dateToCompare);
  const updated = isAfter(formatTodate, date.setMonth(date.getMonth() - 6));

  return updated;
};

export const formatMoney = Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatError = (messages: any) => {
  if (!messages) return [''];

  if (typeof messages === 'string') return [messages];

  const newMessage = !!messages?.length && messages?.reduce((prev: string, current: string) => prev + '\n' + current);
  return newMessage;
};

export const addLeadingZeros = (num?: number | string, zeros?: number): string => {
  if (!num) return '';
  return `${num}`.padStart(zeros ?? 4, '0');
};

export const transformAgencyName = (value: string, char?: number) =>
  value
    .toLowerCase()
    .split(' ')
    .slice(0, char ?? 3)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
